import React from 'react';
import { BaasicInput } from 'core/components';
import { translate } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

const UserPasswordChangeTemplate = ({ userPasswordChangeViewStore, t }) => {
	const { form, loading } = userPasswordChangeViewStore;

	return (
		<form className="ReactModal__form" onSubmit={form.onSubmit}>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('CHANGEPASSWORD')}</h3>
			</div>
			<div className="ReactModal__body">
				<BaasicInput field={form.$('newPassword')} className="fs-mask" showCheckmark={false} />
				<BaasicInput field={form.$('confirmPassword')} className="fs-mask" showCheckmark={false} />
				{form.error && (
					<div>
						<p className="type--color--warning">{translate(form.error)}</p>
					</div>
				)}
			</div>
			<div className="ReactModal__footer">
				<button className="btn btn--med btn--primary spc--bottom--sml" type="submit" disabled={loading}>
					{loading ? (
						<div className="spinnercont spc--right--sml">
							<div className="spinner"></div>
						</div>
					) : null}
					{t('SUBMIT')}
				</button>
			</div>
		</form>
	);
};

export default defaultTemplate(UserPasswordChangeTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/user/pages/UserPasswordChangeTemplate.jsx